import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Film } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const exchange = async () => {
      const hash = window.location.hash || "";
      const params = new URLSearchParams(hash.replace(/^#/, ""));
      const session_id = params.get("session_id");
      if (!session_id) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data.user);
        // Clean fragment
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    };
    exchange();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-4">
        <Film className="w-10 h-10 text-[#FF2A2A] animate-pulse" />
        <p className="font-mono text-xs uppercase tracking-[0.4em] text-white/50">Rolling credits...</p>
      </div>
    </div>
  );
}
